// Mini-item row inside the "Similar items" section of MarketplaceDetail.
// Renders logo/letter + name + kind badge. Clicking replaces the host's
// selectedItem so the detail pane transitions to the new item without
// closing + reopening.

export const MarketplaceDetailSimilarItem = {
  flow: 'x',
  align: 'center',
  gap: 'Z',
  padding: 'Y A',
  borderRadius: 'Y',
  cursor: 'pointer',
  transition: 'Z defaultBezier background',
  background: 'transparent',
  ':hover': { background: 'line' },

  // Clicking a similar item pushes the current `selectedItem` onto
  // `selectedHistory` so the Back button in DetailTopBar can restore
  // it. Grid/row clicks use `selectItemFresh` instead (clears stack).
  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    el.call('selectItemWithHistory', host, {
      id: el.id, kind: el.kind, category: el.category,
      name: el.name, description: el.description, price: el.price,
      logo: el.logo, thumbnail: el.thumbnail,
      _liveKind: el._liveKind
    })
  },

  SimilarLogo: {
    align: 'center center',
    width: 'A',
    height: 'A',
    minWidth: 'A',
    borderRadius: 'Y',
    overflow: 'hidden',
    fontWeight: '700',
    fontSize: 'Y',
    background: (el) =>
      el.parent.logo ? 'white' : el.call('getKindAccent', el.parent.kind, 'bg'),
    color: (el) => el.call('getKindAccent', el.parent.kind, 'fg'),

    // Brand img when logo is present, otherwise letter chip. Nested
    // DOMQL elements — no `html:` string with inline `style=` (Rule 31).
    SimilarLogoImg: {
      hide: (el) => !el.parent.parent.logo || el.parent._imgFailed,
      tag: 'img',
      src: (el) => {
        const slug = el.parent.parent.logo
        return slug ? `https://cdn.simpleicons.org/${slug}` : ''
      },
      alt: (el) => el.parent.parent.name,
      width: '60%',
      height: '60%',
      objectFit: 'contain',
      onRender: (el) => {
        if (!el.node) return
        el.node.onerror = () => {
          el.parent._imgFailed = true
          el.node.style.display = 'none'
          const letter = el.parent.SimilarLogoLetter
          if (letter?.node) letter.node.style.display = ''
        }
      }
    },
    SimilarLogoLetter: {
      hide: (el) => !!el.parent.parent.logo && !el.parent._imgFailed,
      tag: 'span',
      text: (el) => (el.parent.parent.name || '')[0]?.toUpperCase() || '?'
    }
  },

  SimilarName: {
    tag: 'span',
    // `el.parent` IS the mini-item root where the catalog spread lives
    // (name/kind/logo/...). One level of `.parent`, not two — the
    // SimilarLogo nested img/letter pattern walks two levels because
    // they live ONE deeper inside SimilarLogo.
    text: (el) => el.parent.name,
    fontSize: 'Y',
    fontWeight: '500',
    color: 'title',
    flex: '1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  SimilarKindTag: {
    tag: 'span',
    text: (el) => el.parent.kind,
    padding: 'X Y',
    borderRadius: 'Y',
    fontSize: 'X',
    background: 'line',
    color: 'caption',
    textTransform: 'capitalize'
  }
}
